import { BaseModuleI } from "../../interfaces";

export const generatePad = (id: number) => {
    return id.toString().padStart(8, "0");
};


export function separator(numb: string) {
    var str = numb.toString().split(".");
    str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return str.join(".");
};

export const generateRandomPassword = () => {
    const chars = '0123456789abcdefghjkmnopqrstuvwxyzABCDEFGHJKMNOPQRSTUVWXYZ';
    const passwordLength = 7;
    let password = '';
    for (let i = 0; i <= passwordLength; i++) {
        const randomNumber = Math.floor(Math.random() * chars.length);
        password += chars.substring(randomNumber, randomNumber + 1);
    }
    return password;
};

export const collectAccessibleRoutes = (
  modules: BaseModuleI[],
  basePath: string = ""
): string[] => {
  const routes: string[] = [];


  for (const module of modules) {
    const modulePath = module.to || basePath;

    if (module.options) {
      const newRoutes = module.options
        .filter((option) => option.show)
        .map((option) => {
          const optionTo = option.to.startsWith(modulePath)
            ? option.to.replace(modulePath, "").replace(/^\/+/, "")
            : option.to;
          return optionTo.startsWith("/")
            ? `/${normalizeRoute(optionTo)}`
            : `/${normalizeRoute(
                modulePath && optionTo ? `${modulePath}/${optionTo}` : optionTo
              )}`;
        });
      routes.push(...newRoutes);
    }

    if (module.children && module.children.length > 0) {
      const childRoutes = collectAccessibleRoutes(module.children, modulePath);
      routes.push(...childRoutes);
    }

    if (
      module.to &&
      (!module.options || module.options.length === 0) &&
      (!module.children || module.children.length === 0)
    ) {
      const leafRoute = `/${normalizeRoute(module.to)}`;
      routes.push(leafRoute);
    }
  }

  return routes;
};

const normalizeRoute = (route: string): string => {
  return route.replace(/\/+/g, "/").replace(/^\/|\/$/g, "");
};
